import { render } from "./OrderConfirm.vue?vue&type=template&id=73068ed8&scoped=true"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"

import "./OrderConfirm.vue?vue&type=style&index=0&id=73068ed8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73068ed8"

export default script